module.exports = __webpack_public_path__ + "img/ecolesecondairepierre-laporte.13d725a8.png";